// Called by : src/App.vue (select-locale)

<template>
  <multiselect
    v-model="lang"
    class="header select-lang-container"
    :options="options"
    :allow-empty="false"
    :multiple="false"
    :searchable="false"
    :show-labels="false"
    @select="onSelect"
  >
    <div v-if="props && props.option" slot="singleLabel" slot-scope="props" class="px-0 py-2 px-sm-2">
      <span>
        <country-flag :country="props.option.flag" />&nbsp;
        <strong class="text-uppercase">{{ props.option.title }}</strong>
      </span>
    </div>
    <div v-if="props && props.option" slot="option" slot-scope="props" class="px-0 py-2 px-sm-2">
      <span>
        <country-flag :country="props.option.flag" />&nbsp;
        <strong class="text-uppercase">{{ props.option.title }}</strong>
      </span>
    </div>
  </multiselect>
</template>

<script>
// from https://www.npmjs.com/package/vue-switch-lang
// add title next to the flag
// set the country by code
import Multiselect from "vue-multiselect"
import CountryFlag from "vue-country-flag"
import "vue-multiselect/dist/vue-multiselect.min.css"

export default {
  components: {
    Multiselect,
    CountryFlag,
  },
  props: {
    initLang: {
      type: Object,
      default() {
        return {
          title: "en",
          flag: "gb"
        };
      }
    },
    options: {
      type: Array,
      default() {
        return [
          {
            title: "en",
            flag: "gb"
          },
          {
            title: "fr",
            flag: "fr"
          },
          {
            title: "de",
            flag: "de"
          },
        ];
      }
    }
  },
  created() {
    this.lang = this.getLang()
  },
  mounted() {
    if (this.$i18n.locale) {
      this.getLang()
    }
  },
  methods: {
    onSelect(lang) {
      this.$i18n.locale = lang.title
    },
    getLang() {
      let lang = {}
      if (this.$i18n.locale) {
         lang = {
          title: this.$i18n.locale,
          flag: this.options.filter(o => o.title==this.$i18n.locale)[0].flag,
        }
      } else {
        lang = {
          title: "en",
          flag: "gb",
        }
      }
      return lang
    }
  },
  data() {
    return {
      lang: null
    };
  }
};
</script>

<style scoped>
.header {
    display: flex;
    justify-content: center;
    width: 8em;
}
</style>



// WEBPACK FOOTER //
// src/components/header/SelectLocale.vue